// extracted by css-extract-rspack-plugin
export default {"selectMenuUp":"selectMenuUp-XjI8qx","viewCollectionButton":"viewCollectionButton-CNq2WR"};